const Errr = require('errr');

const Constants = require('../constants');
const getProxyRedirectUrl = require('../utils/get-proxy-redirect-url');
const HttpProxy = require('../proxies/http-proxy');
const IdentityService = require('../services/identity-info');
const Config = require('../state/config');

class Eula {

  static async updateEula(licenseAgreement) {
    try {
      const currentSession = await IdentityService.getIdentitySession();
      const url = getProxyRedirectUrl(`${Config.getPrincipleUrl()}${Constants.UserUri}`);
      const body = JSON.stringify({ licenseAgreement });
      const options = { method: Constants.Methods.Put, body };
      await HttpProxy.request(url, options);

      const updatedSession = { ...currentSession, hasAcceptedEula: licenseAgreement };
      IdentityService.setIdentitySession(updatedSession);
      return updatedSession;
    } catch (err) {
      Errr.newError(Constants.Errors.UpdateEula.Message)
        .debug({ licenseAgreement }).appendTo(err).throw();
    }
  }
}

module.exports = Eula;